import React, { useState, useRef } from "react";
import { object, string } from "prop-types";

import ArrowLink from "../../components/ArrowLink/ArrowLink.jsx";
import Icon from "../../components/Icon/Icon.jsx";
import ImageElement from "../../components/ImageElement/ImageElement.jsx";

import CountdownTicker from "./CountdownTicker.jsx";

const propTypes = {
  image: object,
  text: string,
  postText: string,
  link: object,
  postLink: object,
  id: string,
  countdownEnd: string.isRequired,
  interval: string,
  imageCaption: string,
};

const CountdownBannerApp = (props) => {
  const { id, countdownEnd, image, imageCaption, link, postLink, postText } =
    props;

  const [activeEvent, setActiveEvent] = useState(() => {
    const endTime = new Date(countdownEnd).getTime();
    const now = new Date().getTime();
    return endTime - now <= 0;
  });

  const countdownRef = useRef();

  const tickerCompleted = () => {
    setActiveEvent(true);
  };

  const onClose = () => {
    window.sessionStorage.setItem("countdown-banner", id);
    countdownRef.current.parentElement.classList.remove("show-banner");
  };

  return (
    <section className="countdown-banner theme-dark" ref={countdownRef}>
      <div className="countdown-banner__container container container--dark">
        <div className="countdown-banner__close">
          <button
            className="btn"
            onClick={onClose}
            aria-label="hide countdown banner"
          >
            <Icon iconName="close" />
          </button>
        </div>
        {image && (
          <figure className="countdown-banner__figure">
            <ImageElement {...image} />
            {imageCaption && !activeEvent && (
              <figcaption>{imageCaption}</figcaption>
            )}
          </figure>
        )}
        {activeEvent && (
          <div
            className="countdown-banner__message"
            dangerouslySetInnerHTML={{ __html: postText }}
          />
        )}
        {!activeEvent && (
          <div className="countdown-banner__counter-wrapper">
            <CountdownTicker {...props} onCompletion={tickerCompleted} />
          </div>
        )}
        {!activeEvent && link?.href && (
          <div className="countdown-banner__cta">
            <ArrowLink {...link} className="btn btn--ghost" />
          </div>
        )}
        {activeEvent && postLink?.href && (
          <div className="countdown-banner__cta">
            <ArrowLink {...postLink} className="btn btn--ghost" />
          </div>
        )}
      </div>
    </section>
  );
};
CountdownBannerApp.propTypes = propTypes;
export default CountdownBannerApp;
